export default "__VITE_ASSET__DDv$ZCze__"